import { SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  error?: string;
}

export function FailedToVerifyWebhookMessage({ error }: Props) {
  const { t } = useTranslation();
  if (!error) {
    return null;
  }

  return (
    <SectionMessage
      sectionTitle={error}
      type="danger"
      testID="webhook-verification-failed"
      icon="info"
    >
      {t(
        "Either we didn't receive the challenge string back, or we've received an error from this url. Check your system and retry."
      )}
    </SectionMessage>
  );
}
